var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"headimg",style:({width:_vm.size+'px',height:_vm.size+'px',backgroundImage:'url('+_vm.imgUrl+')'})})}
var staticRenderFns = []

export { render, staticRenderFns }